import Header from './header.component';

export default Header;